<script setup>
import { useAttrs } from 'vue';
import logoSrc from 'dashboard/assets/images/metasales-logo.svg';

const attrs = useAttrs();
</script>

<template>
  <img v-bind="attrs" :src="logoSrc" alt="MetaSales" />
</template>
